import { render, staticRenderFns } from "./scroll-text.vue?vue&type=template&id=3c50e5e1"
import script from "./scroll-text.vue?vue&type=script&lang=js"
export * from "./scroll-text.vue?vue&type=script&lang=js"
import style0 from "./scroll-text.vue?vue&type=style&index=0&id=3c50e5e1&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports